import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-course-outcomes',
  templateUrl: './course-outcomes.component.html',
  styleUrls: ['./course-outcomes.component.scss']
})
export class CourseOutcomesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
